import { ThemeProvider } from '@mui/material/styles';
import { getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import VitalLineChart from './VitalLineChart';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';

import './index.css';

const formatDataPoints = (dataset) => {
  return dataset.map((item) => {
    return {
      ...item,
      data: item.data.map((point) => ({
        ...point,
        x: new Date(point.x),
      })),
    };
  });
};

export default (element, store) => {
  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding });
  root.render(
    <ErrorBoundary>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <VitalLineChart
            data={formatDataPoints(JSON.parse(element.dataset.dataset))}
            color={element.dataset.color}
            label={element.dataset.label}
            unit={element.dataset.unit}
            locale={element.dataset.localename}
            icon={element.dataset.icon}
            serie={element.dataset.serie}
          />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>,
  );

  return () => {
    root.unmount();
  };
};
